export default function () {
    return {
        restrict: 'E',
        replace: true,
        template: require('../partials-html/login-screens.html')
    };
}



// WEBPACK FOOTER //
// ./Client/app/sink/main/partials-js/loginScreens.js